import { useContext } from 'react'

import { Progress } from 'antd'
import { color } from 'd3-color'
import LiquidFillGauge from 'react-liquid-gauge'
import { useSelector } from 'react-redux'
import { faMeh, faSmile, faFrown } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Loading from '../shared/Loading'
import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'
import { GlobalContext } from '../../Providers/GlobalProvider'
import { InstitutionOptions } from '../../utils/constants'
import BlurContent from '../shared/BlurContent'

const LargeScoreSummaryCard = ({ colorCircle, entityData, fillColor, gradientStops, loading, title }) => {
  const t = useSelector(selectTranslate)
  const { modules } = useContext(GlobalContext)

  const isRecruitmentModuleEnabled = modules[InstitutionOptions.RECRUITMENT_MODULE]
  const usePlaceholder = !isRecruitmentModuleEnabled
  const placeholderPercentValue = 67
  const placeholderPercentText = `${placeholderPercentValue}`
  const placeholderStats = {
    feedbackCount: 67,
    countAllEvaluation: 67,
    negativeEvaluation: 67,
    neutralEvaluation: 67,
    positiveEvaluation: 67
  }

  const percentLabel = value => (
    <span style={{ color: '#5b5b5b' }}>
      {value}
      <span style={{ fontSize: '14px' }}>%</span>
    </span>
  )

  return (
    <div className='score-summary-card-large'>
      <div className='title-score-summary-card'>{title}</div>
      {loading && (<Loading size='4x' />)}
      {!loading && (
        <div className='card-content'>
          <div className='charts-score-summary-card'>
            <div className='chart-score-summary-card'>
              <Progress
                type='circle'
                strokeColor={{
                  '0%': '#108ee9',
                  '100%': '#87d068'
                }}
                percent={entityData.feedbackSum}
                width={120}
                height={120}
                format={(percent) => (
                  <span style={{ color: '#5b5b5b' }}>
                    {percent}
                    <span style={{ fontSize: '14px' }}>%</span>
                  </span>
                )}
              />
              <div style={{ textAlign: 'left', marginLeft: '15px' }}>
                <p
                  style={{
                    fontSize: '18px'
                  }}
                >
                  {t('score.card.score.feedbackSum.institution')}
                </p>
                <p>{t('score.card.score.feedbackSum.institution.description')}</p>
              </div>
            </div>
            <div className='chart-score-summary-card'>
              <div
                style={{
                  height: 120,
                  width: 120
                }}
              >
                <LiquidFillGauge
                  style={{ margin: '0' }}
                  width={120}
                  height={120}
                  value={entityData.responseRate}
                  textSize={0.8}
                  textOffsetX={0}
                  textOffsetY={10}
                  waveAnimation
                  waveFrequency={2}
                  waveAmplitude={1}
                  gradient
                  gradientStops={gradientStops}
                  circleStyle={{
                    fill: colorCircle
                  }}
                  waveStyle={{
                    fill: fillColor
                  }}
                  textStyle={{
                    fill: color('#5b5b5b').toString()
                  }}
                  waveTextStyle={{
                    fill: color('#fff').toString(),
                    fontFamily: 'Arial'
                  }}
                />
              </div>
              <div style={{ textAlign: 'left', marginLeft: '15px' }}>
                <p
                  style={{
                    fontSize: '18px'
                  }}
                >
                  {t('score.card.score.responseRate')}
                </p>
                <p>{t('score.card.score.responseRate.description')}</p>
              </div>
            </div>
          </div>
          <BlurContent
            blurIntensity='7px'
            activated={!isRecruitmentModuleEnabled}
          >
            <div className='charts-score-summary-card'>
              <div className='chart-score-summary-card'>
                <Progress
                  type='circle'
                  strokeColor={{
                    '0%': '#108ee9',
                    '100%': '#87d068'
                  }}
                  width={120}
                  height={120}
                  percent={usePlaceholder ? placeholderPercentValue : entityData.institutionFeedbackSum}
                  format={usePlaceholder ? () => percentLabel(placeholderPercentText) : percent => percentLabel(percent)}
                />
                <div style={{ textAlign: 'left', marginLeft: '15px' }}>
                  <p
                    style={{
                      fontSize: '18px'
                    }}
                  >
                    {t('score.card.score.institutionFeedbackSum')}
                  </p>
                  <p>{t('score.card.score.institutionFeedbackSum.description')}</p>
                </div>
              </div>
              <div className='chart-score-summary-card'>
                <div
                  style={{
                    height: 120,
                    width: 120
                  }}
                >
                  <LiquidFillGauge
                    style={{ margin: '0' }}
                    width={120}
                    height={120}
                    value={usePlaceholder ? placeholderPercentValue : entityData.institutionResponseRate}
                    textSize={0.8}
                    textOffsetX={0}
                    textOffsetY={10}
                    waveAnimation
                    waveFrequency={2}
                    waveAmplitude={1}
                    gradient
                    gradientStops={gradientStops}
                    textRenderer={usePlaceholder ? () => `${placeholderPercentValue}%` : undefined}
                    circleStyle={{
                      fill: colorCircle
                    }}
                    waveStyle={{
                      fill: fillColor
                    }}
                    textStyle={{
                      fill: color('#5b5b5b').toString()
                    }}
                    waveTextStyle={{
                      fill: color('#fff').toString(),
                      fontFamily: 'Arial'
                    }}
                  />
                </div>
                <div style={{ textAlign: 'left', marginLeft: '15px' }}>
                  <p
                    style={{
                      fontSize: '18px'
                    }}
                  >
                    {t('score.card.score.responseRateInstitution')}
                  </p>
                  <p>{t('score.card.score.responseRateInstitution.description')}</p>
                </div>
              </div>
            </div>
          </BlurContent>
          <BlurContent blurIntensity='7px' activated={!isRecruitmentModuleEnabled}>
            <div className='evaluations-score-summary-card'>
              <p style={{ fontSize: '18px', fontWeight: 'bolder', margin: '0', marginBottom: '10px' }}>
                {t('score.card.score.statistics')}
              </p>
              <ul
                style={{
                  textAlign: 'left',
                  paddingLeft: '5px',
                  listStyle: 'none',
                  lineHeight: '1.75'
                }}
              >
                <li style={{ marginBottom: '10px' }}>
                  {t('score.card.score.statistics.feedbackRatio', {
                    count: usePlaceholder ? placeholderStats.feedbackCount : entityData.feedbackCount,
                    total: usePlaceholder ? placeholderStats.countAllEvaluation : entityData.countAllEvaluation
                  })}
                </li>
                <li>
                  <FontAwesomeIcon icon={faFrown} size='lg' color='#cf1322' />{' '}
                  <span>{usePlaceholder ? placeholderStats.negativeEvaluation : entityData.negativeEvaluation}</span>
                </li>
                <li>
                  <FontAwesomeIcon icon={faMeh} size='lg' color='#d46b08' />{' '}
                  <span>{usePlaceholder ? placeholderStats.neutralEvaluation : entityData.neutralEvaluation}</span>
                </li>
                <li>
                  <FontAwesomeIcon icon={faSmile} size='lg' color='#389e0d' />{' '}
                  <span>{usePlaceholder ? placeholderStats.positiveEvaluation : entityData.positiveEvaluation}</span>
                </li>
              </ul>
            </div>
          </BlurContent>
        </div>
      )}
    </div>
  )
}

export default LargeScoreSummaryCard
